// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getFilteredSearchResults} from '../services/helpers';
import {getRgaSubtypes} from '../../shared/repositories';
import {readOpenPartRequests} from '../../open-parts-requests/action-creators/open-part-requests';
import {updateSearchResults} from '../../search/action-creators/search';

const getAllowedDealers = state =>
    state.partReturns.search.facets.dealerAccountsFacet.allowedDealers;

const getUpdatedSelectedStatuses = state =>
    state.partReturns.search.facets.statusFacet.selectedStatuses.length ?
        [] : state.partReturns.search.facets.statusFacet.allowedStatuses;

export const getRequestTypes = query =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const allowedTypes = await getRgaSubtypes();

            dispatch({
                allowedTypes,
                type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_ALLOWED_REQUEST_TYPES
            });

            if (getState().partReturns.search.facets.dealerAccountsFacet.isInitialLoad) {

                dispatch({
                    requestTypes: allowedTypes,
                    type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_SELECTED_REQUEST_TYPES
                });

                dispatch({
                    type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_IS_INITIAL_LOAD
                });

            }

            updateSearchResults(query)(dispatch, getState);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const initializeFacets = () =>

    (dispatch, getState) => {

        const state = getState();

        if (state.partReturns.search.facets.isInitialLoad) {

            dispatch({
                allowedRequestTypes: state.partReturns.search.facets.requestTypes.allowedTypes,
                dealers: state.user.details.settings.dealer.accounts.selectedAccounts,
                isInitialLoad: false,
                statuses: state.user.details.settings.partReturns.status.selectedStatuses,
                type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS
            });

            readOpenPartRequests()(dispatch, getState);

        }

    };

export const updateFacetsDateRange = dateRange => ({
    dateRange,
    type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_DATE_RANGE
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_DEALER_FACET_INPUT,
    value
});

export const updateFacetsDealer = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_DEALER
});

export const toggleFacetsDealers = () =>

    (dispatch, getState) => {

        dispatch({
            allowedDealers: getAllowedDealers(getState()),
            type: actions.TOGGLE_PART_REQUESTS_SEARCH_FACETS_DEALERS
        });

    };

export const updateFacetsStatus = (status, isSelected) => ({
    isSelected,
    status,
    type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_STATUS
});

export const updateFacetsStatuses = () =>

    (dispatch, getState) => {

        dispatch({
            statuses: getUpdatedSelectedStatuses(getState()),
            type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_STATUSES
        });

    };

export const updateSelectedPartRequestType = (requestType, isSelected) => ({
    isSelected,
    requestType,
    type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS_SELECTED_REQUEST_TYPE
});

export const applyFacets = () =>

    (dispatch, getState) => {

        const state = getState();

        const selectedRequestTypes = state.partReturns.search.facets.requestTypes.selectedTypes;
        const selectedDealers = state.partReturns.search.facets.dealerAccountsFacet.selectedDealers;
        const selectedStatuses = state.partReturns.search.facets.statusFacet.selectedStatuses;
        const selectedDateRange = state.partReturns.search.facets.requestDateFacet.dateRange;
        const currentSearchResults = state.partReturns.search.searchResults;

        dispatch({
            filteredSearchResults: getFilteredSearchResults(currentSearchResults, selectedDealers, selectedStatuses, selectedDateRange, selectedRequestTypes),
            type: actions.FILTER_PART_REQUESTS_SEARCH_RESULTS
        });

    };

export const resetFacets = () =>

    (dispatch, getState) => {

        const state = getState();

        dispatch({
            allowedRequestTypes: state.partReturns.search.facets.requestTypes.allowedTypes,
            dealers: state.user.details.settings.dealer.accounts.selectedAccounts,
            isInitialLoad: false,
            statuses: state.user.details.settings.partReturns.status.selectedStatuses,
            type: actions.UPDATE_PART_REQUESTS_SEARCH_FACETS
        });

        const filteredSearchResults = state.partReturns.search.searchResults;

        dispatch({
            filteredSearchResults,
            type: actions.FILTER_PART_REQUESTS_SEARCH_RESULTS
        });

    };



// WEBPACK FOOTER //
// ./src/part-requests/search/action-creators/facets.js